import React from 'react';

import Summary from "../../components/Summary/Summary"

import Skills from "../../components/Skills/Skills"

const Dashboard = () => (
  <div>
    
    <div className="d-sm-flex align-items-center justify-content-between mb-4">
      <h3 className="m-0 font-weight-bold mb-4">Dashboard</h3>

    </div>

    { /* Summary */ }

      <Summary />
      
    { /* End of Summary */}

    {/*Skills */}
     
        <Skills />
     
    { /* End of Skills */}

</div>
);

export default Dashboard;